export default "__VITE_ASSET__BFvDdy5b__"